import React from 'react';
import LocationTemplate from './LocationTemplate';

const KillDevilHillsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kill Devil Hills"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27948"]}
      latitude={36.0287}
      longitude={-75.6727}
      population={7633}
      historicalFact="Site of the Wright Brothers' first powered flight (1903), named after a local rum called 'Kill Devil.'"
      nearbyTowns={[
        "Nags Head, NC",
        "Kitty Hawk, NC",
        "Manteo, NC",
        "Southern Shores, NC",
        "Duck, NC",
        "Colington, NC",
        "Dare Mainland, NC",
        "Elizabeth City, NC"
      ]}
    />
  );
};

export default KillDevilHillsPage;